import Vue from 'vue'
import Router from 'vue-router'
import ApiMenu from '../apis/api-menu'

Vue.use(Router)
export default new Router({
  routes: [
    { path: '/index/home', name: '首页', meta: { title: '首页' }, component: require('@/pages/index/home').default },
    { path: '/index/login', name: '登录', meta: { title: '登录' }, component: require('@/pages/index/login').default },
    { path: '/index/changePass', name: '找回密码', meta: { title: '找回密码' }, component: require('@/pages/index/changePass').default },
    ...ApiMenu.getMenuRouter(),
    { path: '/index/404', name: '404', meta: { title: '404' }, component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages/index/404`) },
    { path: '/index/test', name: '测试页面', meta: { title: '测试页面' }, component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages/index/test`) },
    { path: '*', name: '找不到页面', meta: { title: '登录' }, redirect: '/index/login' }
  ]
})
